


























import { AxiosResponse } from 'axios';
import { Component, Prop, Vue } from 'vue-property-decorator';
import moment from 'moment';

import {
	WaterMetersApi,
	WaterMonitorsApi,
	WaterTotalizerCorrection,
	WaterTotalizerCorrectionDynamoItem,
} from '@/api';
import { ApiUtils } from '@/common/ApiUtils';
import { Constants } from '@/common/Constants';
import Toast from '@/components/display/toast.vue';

import TotalizerCorrectionModal from './TotalizerCorrectionModal.vue';
import { WaterCorrectionsService } from '@/services/water-corrections-service';

@Component({
	components: {
		TotalizerCorrectionModal,
	},
})
export default class TotalizerCorrectionsTab extends Vue {
	@Prop({ required: true, type: Number })
	public entityId!: number;

	@Prop({ required: true, type: String })
	public entityType!: string;

	public totalizerCorrections: WaterTotalizerCorrection[] | null = null;
	public loading: boolean = true;

	private toast: Toast = new Toast();

	public async created(): Promise<void> {
		await this.onCorrectionApplied();
		this.loading = false;
	}

	public getCorrectionDate(correction: WaterTotalizerCorrection): string {
		return moment(correction.correctionTs! * 1000).format('h:mma dddd Do MMMM YYYY');
	}

	public async onCorrectionApplied(): Promise<void> {
		this.totalizerCorrections = await this.fetchTotalizerCorrections();
	}

	public async fetchTotalizerCorrections(): Promise<WaterTotalizerCorrection[] | null> {
		const res = await WaterCorrectionsService.getTotalizerCorrections(
			this.entityType,
			this.entityId,
		);
		if (res?.error) {
			this.toast.makeToast(res.error, 'Error', 'danger');
			return null;
		}
		return res.data;
	}
}
